module.exports = __webpack_public_path__ + "img/Presentations.ba28505e.svg";